function guAddToCart(evt){
    evt.preventDefault();
    const cartDrawer = document.getElementById('cart-drawer');
    const variantId = evt.target.dataset.variant;
    const items = [{
                'id': variantId,
                'quantity': 1,
                'properties': {
                    '__xs': true,
                }
            }];
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({items:items}),
    }).then((response) => response.text()).then((data) => {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true,
        }));
        cartDrawer.show();
    });
}

document.addEventListener('click', (evt) => {
    if(evt.target.dataset.type === 'gu-pr-atc'){
        guAddToCart(evt);
    }
});
